'use client';

import { AlignJustify } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { Button } from 'shared/ui/button';
import { BalanceDisplay } from 'widgets/balance-display';
const SheetMenu = dynamic(() => import('./sheet-menu').then(module => module.SheetMenu));
export const MobileSheetMenu = ({
  userName
}: {
  userName: string | undefined;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="flex items-center gap-2 md:hidden" data-sentry-component="MobileSheetMenu" data-sentry-source-file="mobile-sheet-mentu.tsx">
      <BalanceDisplay data-sentry-element="BalanceDisplay" data-sentry-source-file="mobile-sheet-mentu.tsx" />
      <Button size="sm" variant="ghost" onClick={() => setIsOpen(true)} className="md:hidden" data-sentry-element="Button" data-sentry-source-file="mobile-sheet-mentu.tsx">
        <AlignJustify className="size-5" data-sentry-element="AlignJustify" data-sentry-source-file="mobile-sheet-mentu.tsx" />
      </Button>
      <SheetMenu open={isOpen} setOpen={setIsOpen} userName={userName} data-sentry-element="SheetMenu" data-sentry-source-file="mobile-sheet-mentu.tsx" />
    </div>;
};